import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController  } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../../providers/global/global';
import {DatePipe} from '@angular/common';
@IonicPage()
@Component({
  selector: 'page-banner-alarm',
  templateUrl: 'banner-alarm.html',
})
export class BannerAlarmPage {
  lista: string[];
  count: number=0;
  data: Observable<any>;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public global: GlobalProvider,
    public alerCtrl: AlertController,
    public datepipe: DatePipe,
    ) {
  }




  public atualizar_banner(){
    var url='http://iot.digicomp.com.br/api/public/ping/banner_alarm';
    this.global.check_jwt();

    let body=new FormData();
    body.append('db',this.global.banco);
    body.append('jwt', this.global.token);
    this.data=this.http.post(url,body);
    this.data.subscribe(data=>{
      for (let i = 0; i < data.length; i++) {
        data[i]["valor"]= +parseFloat(data[i]["valor"]).toFixed(2);
        // Em Alarme e não reconhecido
        if (data[i]["timestamp_reset"]=="0000-00-00 00:00:00" && data[i]["timestamp_ack"]=="0000-00-00 00:00:00") {
          data[i]["cor_card"]="#c60000";
        };
        // Em Alarme e reconhecido 
        if(data[i]["timestamp_reset"]=="0000-00-00 00:00:00" && data[i]["timestamp_ack"]!="0000-00-00 00:00:00"){
          data[i]["cor_card"]="#dbd300";
        };
        // Sem Alarme e nao reconhecido 
        if(data[i]["timestamp_reset"]!="0000-00-00 00:00:00" && data[i]["timestamp_ack"]=="0000-00-00 00:00:00"){
          data[i]["cor_card"]="#0000c6";
        };
        // Sem Alarme e reconhecido 
        if(data[i]["timestamp_reset"]!="0000-00-00 00:00:00" && data[i]["timestamp_ack"]=="0000-00-00 00:00:00"){
          data[i]["cor_card"]="#00c600";
        }
      };
      this.lista=data;
    });
  }





  public reconhecer_alarm(card){
    if (card.timestamp_ack!='0000-00-00 00:00:00') {
      console.log("Já reconhecido!!");
      return
    }
    let confirm = this.alerCtrl.create({
      title: 'Deseja realmente reconhecer?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Confirmar',
          handler: () => {
            //console.log('Agree clicked');
            try {
              var url='http://iot.digicomp.com.br/api/public/ping/ack_alarm';
              this.global.check_jwt();

              if (card.name=="" || this.global.securityLevel>3) {
                return
              }
              let body=new FormData();
              body.append('db',this.global.banco);
              body.append('user',this.global.userId);
              body.append('client','ping');      
              body.append('id',card.id);
              body.append('jwt', this.global.token);
              this.data=this.http.post(url,body);
              this.data.subscribe(data=>{
                if (data=="1") {
                  console.log("Reconhecido!!!");
                  this.atualizar_banner();
                }
              });
            }
            catch(e){console.log(e);}
          }
        }
      ]
    });
    confirm.present();
  }




  public reset_card(card){
    if (card.timestamp_reset!=='0000-00-00 00:00:00' || this.global.securityLevel>0) {
      return
    }
    let confirm = this.alerCtrl.create({
      title: 'Deseja realmente resetar o alarme?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Confirmar',
          handler: () => {
            console.log('Agree clicked');
            try {
              var url='http://iot.digicomp.com.br/api/public/ping/rst_alarm';
              this.global.check_jwt();

              if (card.name=="" || this.global.securityLevel>0) {
                return
              }
              let body=new FormData();
              body.append('db',this.global.banco);
              body.append('user',this.global.userId);
              body.append('client','ping');      
              body.append('id',card.id);
              body.append('jwt', this.global.token);
              this.data=this.http.post(url,body);
              this.data.subscribe(data=>{
                if (data=="1") {
                  console.log("Resetado");
                  this.atualizar_banner();
                }
              });
            }
            catch(e){console.log(e);}
          }
        }
      ]
    });
    confirm.present();
  }



  public reset_alarm(card)  {
      this.count++;
      setTimeout(() => {
        if (this.count == 1) {
          this.count = 0;
        }if(this.count > 1){
          this.count = 0;
          console.log("3");
          this.reset_card(card);
        }
      }, 250);
  }



  resetIsEnabled(card){
    if (card.timestamp_reset!=='0000-00-00 00:00:00') {
      return false;
    }
    if (card.name=="") {
      return false;
    }
    else{
      return true;
    }

  }



  reconhecerIsEnabled(card){
    if (card.timestamp_ack!='0000-00-00 00:00:00') {
      return false;
    }
    if (card.name=="" || this.global.securityLevel>3) {
      return false;
    }
    else{
      return true;
    }
  }




  ionViewDidEnter() {
    this.atualizar_banner();
  }
}



// WEBPACK FOOTER //
// ./src/pages/banner-alarm/banner-alarm.ts